import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';

import { Lang } from 'src/app/models/lang';
import { Strings } from '../../../const/strings';
import { LangService } from 'src/app/services/lang.service';
import { CarDetail } from 'src/app/models/car';

@Component({
  selector: 'app-car-upper-price',
  templateUrl: './car-upper-price.component.html',
  styleUrls: ['./car-upper-price.component.scss']
})
export class CarUpperPriceComponent implements OnInit {

  @Output() sendAdsTelEvent = new EventEmitter<string>();
  @Input() car: CarDetail;
  @Input() lang: Lang;

  appUrl: string;
  strings = Strings;

  constructor(
    private langService: LangService,
  ) { }

  ngOnInit(): void {
    this.appUrl = this.langService.getAppUrl();
  }

  clickTelLink(event: Event) {
    event.preventDefault();
    const url = 'tel:' + this.strings.carDetail.supportTelNumber[this.lang];
    this.sendAdsTelEvent.emit(url);
  }

}
